import React from 'react'
import { useState } from 'react'
import { useReducer, useEffect } from 'react'
import validator from '../../Validator/Validator'

const inputReducer = (state, action) => {
    switch (action.type) {
        case 'CHANGE':
            return {
                ...state,
                value: action.value,
                isValid: action.value.length ? validator(action.value, action.validitation) : null
            }
        default: {
            return state
        }
    }
}

export default function Input(props) {
    const [mainInput, Dispatch] = useReducer(inputReducer, {
        value: '',
        isValid: null,
    })
   const [inputValue,setInputValue] = useState()
    useEffect(() => {
        props.onInputHandler(props.id, mainInput.value, mainInput.isValid)
    }, [mainInput.value,props.onInputHandler])

    const onChangeHandler = (e) => Dispatch({
        type: 'CHANGE',
        value: e.target.value,
        validitation: props.validitation
    })

    return (
        <>
            <input type={props.type}
                placeholder={props.placeholder}
                className={`${props.className} ${mainInput.isValid == null ? '' : mainInput.isValid ? 'valid' : 'notValid'}`}
                onChange={onChangeHandler}
            />
            <span className={`input-message ${mainInput.isValid === false ? 'active' : ''}`}>
                {props.placeholder} اشتباه است
            </span>
        </>

    )
}